import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  createSonarQubeClient,
  mockSonarQubeApi,
  sonarqubeApiRef,
} from '@internal/plugin-sonarqube-react';
import {
  createDevBoxClient,
  devboxApiRef,
  mockDevBoxApi,
} from '@internal/plugin-devbox-react';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: sonarqubeApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    // sonarqube.useMockApi is only ever true via local-dev-server-only.yaml.
    factory: ({ configApi, discoveryApi, fetchApi }) =>
      configApi.getOptionalBoolean('sonarqube.useMockApi')
        ? mockSonarQubeApi
        : createSonarQubeClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: devboxApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    // devbox.useMockApi is only ever true via local-dev-server-only.yaml.
    factory: ({ configApi, discoveryApi, fetchApi }) =>
      configApi.getOptionalBoolean('devbox.useMockApi')
        ? mockDevBoxApi
        : createDevBoxClient({ discoveryApi, fetchApi }),
  }),
];
